import { defineStore } from "pinia"
import type { Log } from "~/models/log"
import type { ApiResponse } from "~/types/api"

// log :: search logs
export interface SearchLogsRequest {
	user?: string
	search?: string
	page?: number
	limit?: number
}
export interface SearchLogsResponse extends ApiResponse {
	data: {
		logs: Log[]
		total: number
	}
}
const SearchLogs = {
	method: "GET" as const,
	url: () => `logs/search`
}

export const useLogApiUrl = () => ({
	SearchLogs
})

export const useLogStore = defineStore("log", () => {
	const state = {}

	const searchLogs = async (formData: SearchLogsRequest) => {
		const data = await $fetch<SearchLogsResponse>(SearchLogs.url(), {
			...useFetchConfig(),
			method: SearchLogs.method,
			query: formData
		})
		return data.data
	}

	return {
		...state,
		searchLogs
	}
})
